module.exports = __webpack_public_path__ + "static/media/check-circle-line.c7d09116.svg";